// Código de financiera del catálogo → `ExternalProviderEnum` del type-kit, que es lo que valida el silo.
import { ExternalProviderEnum } from '@fiado/type-kit/bin/retailWizard/enums/ExternalProviderEnum';

/** Grafías del catálogo y de loan-offerings que no coinciden con el enum. */
const CATALOG_CODE_TO_PROVIDER: Readonly<Record<string, ExternalProviderEnum>> = {
    KREDIYA: ExternalProviderEnum.CREDIYA,
    KY: ExternalProviderEnum.CREDIYA,
    PJ: ExternalProviderEnum.PAYJOY,
};

const PROVIDERS = new Set<string>(Object.values(ExternalProviderEnum));

/** El valor del enum para un código de financiera; uno desconocido viaja tal cual y el silo lo rechaza. */
export function toExternalProvider(code: string): string {
    const upper = code.trim().toUpperCase();
    if (PROVIDERS.has(upper)) return upper;
    return CATALOG_CODE_TO_PROVIDER[upper] ?? upper;
}
